$.fn.NewsCarousel = function(options) {
  let self = $(this),
  swiper = self.find('.carousel').data('carousel').swiper
  var selected_slide = self.find('[data-swiper-slide-index='+swiper.realIndex+']')
  let slide_image_url = selected_slide.find('.card-new__image img').attr('src')
  let section_image_object = self.closest('.bg-placement--half-right').find('.bg-image')
  let new_section_image_object = section_image_object.clone();
  section_image_object.css('background-image', 'url(' + slide_image_url + ')');
  new_section_image_object.css('background-image', 'url(' + slide_image_url + ')');
  new_section_image_object.addClass('bg-image-copy');
  new_section_image_object.hide();
  new_section_image_object.insertAfter(section_image_object);

  swiper.on('slideChange', function () {
    new_section_image_object.hide();
    var selected_slide = self.find('[data-swiper-slide-index='+swiper.realIndex+']')
    slide_image_url = selected_slide.find('.card-new__image img').attr('src')
    $('<img/>').attr('src', slide_image_url).on('load', function() {
       $(this).remove();
       new_section_image_object.css('background-image', 'url(' + slide_image_url + ')');
       new_section_image_object.fadeIn( "fast", function() {
         section_image_object.css('background-image', 'url(' + slide_image_url + ')');
       });
    });
  });

  return function() {
    return self
  }()
}
